import { convertToRgba } from './convertToRgba';
export const convertColorsToRgba = (colors) => Object.keys(colors).reduce((result, colorName) => {
    const color = colors[colorName];
    const value = typeof color === 'object'
        ? convertColorsToRgba(color)
        : convertToRgba(color);
    if (value) {
        result[colorName] = value;
    }
    return result;
}, {});
//# sourceMappingURL=convertColorsToRgba.js.map